import { FC } from 'react'
import Link from 'next/link'
import s from './Filters.module.css'
import cn from 'classnames'
import { useTranslation } from 'next-i18next'
import { ShopifyCollection } from '@types'

type FiltersProps = {
  activeCategory?: string
  categories: ShopifyCollection[]
}

const Filters: FC<FiltersProps> = ({ activeCategory, categories }) => {
  const { t } = useTranslation(['common'])

  return (
    <header>
      <nav>
        <h2 className="text-2xl">{t('common:categories.title')}</h2>
        <hr className={s.divider} />
        <ul className="mt-8">
          <li>
            <Link href="/products"><a className={cn(s.filterLink, {[s.filterLinkActive]: !activeCategory})}>{t('common:categories.all')}</a></Link>
          </li>
          {categories.map(c => (
            <li className="mt-4" key={c.handle}>
              <Link href={`/products${c.path.value}`}><a className={cn([s.filterLink, {[s.filterLinkActive]: activeCategory === c.handle}])}>{c.title}</a></Link>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  )
}

export default Filters
